"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function (Drupal) {
  Drupal.behaviors.scrollOutGallery = {
    attach: function attach(context, settings) {
      var mosaic = document.querySelector('.block.scroll-out-gallery');
      var body = document.body;
      if (!mosaic || body.classList.contains('user-logged-in')) {
        return;
      }

      // combat dart layout
      var mosaicParent = mosaic.closest('.layout-bg-content-container');
      mosaicParent.classList.add('has-no-layout');
      gsap.registerPlugin(ScrollTrigger);
      var topSpacing = window.pageYOffset + mosaic.getBoundingClientRect().top;

      /*
       * Get scroll position of mosaic to reset
       */
      var mosaicScrollY = function mosaicScrollY() {
        window.scrollTo({
          left: 0,
          top: topSpacing
        });
      };

      /*
       * Clean up gsap residue to static layout
       * @param: element {object} html element
       */
      var mosaicDestroy = function mosaicDestroy(element) {
        var items = element.querySelectorAll('.field__items > .field__item');
        var pin = document.querySelector('.pin-spacer'); // injected from gsap

        _toConsumableArray(items).forEach(function (i) {
          i.style.transform = 'scale(1)';
          i.style.transition = 'none';
        });
        if (pin) {
          pin.style = '';
          element.style.transform = 'none';
          mosaicScrollY();
        }
        mosaic.classList.add('is-started');
        mosaic.classList.add('is-finished');
      };

      /*
       * gsap trigger mosiac implode conditionally
       */
      ScrollTrigger.matchMedia({
        '(min-width: 1024px)': function minWidth_1024px() {
          var mosaicSt = gsap.timeline({
            scrollTrigger: {
              trigger: '.block.scroll-out-gallery',
              start: 'top 0',
              end: "+=".concat(window.innerHeight * 3),
              // @todo kinda guessing here with a window height multiple. maybe something better?
              scrub: true,
              pin: true,
              markers: false,
              pinSpacing: true,
              once: true,
              toggleClass: 'is-started',
              onLeave: function onLeave() {
                return mosaicDestroy(mosaic);
              }
            }
          });
          mosaicSt.to('.block.scroll-out-gallery .field__items > .field__item:nth-child(1)', {
            scale: 1,
            duration: 5
          }).to('.block.scroll-out-gallery .field__items > .field__item:not(:nth-child(1))', {
            scale: 1,
            duration: 4.0,
            delay: 1.0
          }, '-=5');
        },
        '(max-width: 1023px)': function maxWidth_1023px() {
          mosaicDestroy(mosaic);
        },
        '(prefers-reduced-motion: reduce)': function prefersReducedMotion_reduce() {
          mosaicDestroy(mosaic);
        }
      });
    }
  };
})(Drupal);